import axios from 'axios';

import * as Formatters from './format';
import * as DOMHelpers from './DOMHelpers';
import * as SortHelper from './SortHelper';

export * from './filters';
export { Formatters, DOMHelpers, SortHelper };

/**
 * Checks if the error exception is a request cancelation error
 * @returns {Boolean}
 */
export const isRequestCancelation = (ex) => axios.isCancel(ex);



// WEBPACK FOOTER //
// ./src/common/Helpers/index.js